import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
  apiKey: "AIzaSyC5vOiigqopjN2M3C8IUvx2lSpBDQISIzc",
  authDomain: "tradeviser-firebase-prod.firebaseapp.com",
  databaseURL: "https://tradeviser-firebase-prod-default-rtdb.firebaseio.com",
  projectId: "tradeviser-firebase-prod",
  storageBucket: "tradeviser-firebase-prod.firebasestorage.app",
  messagingSenderId: "777757664069",
  appId: "1:777757664069:web:b905350e5faf58411d142c"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getDatabase(app);
export const googleProvider = new GoogleAuthProvider();
